<div class="share_link" align="center" style="margin-top:60px">
    <h4>Share this link with your friends to compare</h4>
    <p class="text-center">{{baseLinkCode}}</p>
</div>
<div class="row share_link" align="center" style="margin-top: 35px; margin-bottom: 35px; width: 390px;">
    <div class="col-4">
        <img src="./assets/img/facebook.png" (click)="onclickFb()" alt="">
    </div>
    <div class="col-4">
        <img src="./assets/img/whatsup.png" (click)="onclickwhatapp()" alt="">
    </div>
    <div class="col-4">
        <img src="./assets/img/Twitter.png" (click)="onclickTwitter()" alt="">
    </div>
</div>
<style>
    ::ng-deep.mat-bottom-sheet-container {
        padding: 0px !important;
        box-sizing: border-box;
        display: block;
        outline: 0;
        max-height: 600vh !important;
        overflow: auto;
        border-top-left-radius: 16px !important;
        border-top-right-radius: 16px !important;
    }

    ::ng-deep.mat-bottom-sheet-container-large {
        min-width: 380px;
        max-width: 380px;
        min-height: 100px !important;
        max-height: 300px !important;
    }
</style>